import { Container, Row, Col } from 'react-bootstrap'
import { IoMdMegaphone } from 'react-icons/io'
import { FaRocket } from 'react-icons/fa'
import { FaCamera } from 'react-icons/fa'
import { MdDraw } from 'react-icons/md'
import { MdConnectWithoutContact } from 'react-icons/md'
import { FaCode } from 'react-icons/fa'

function Highlights() {
  const elements = [
    {
      title: 'MARKETING DIGITAL',
      text: 'Planejamento Estratégico de Marketing como principal pilar, e Marketing Digital, Comunicação Corporativa, Branding e Identidade Visual, Publicidade e Propaganda, Criação de Campanhas Publicitárias, Ativação de marca, Cobertura e Execução de Eventos, Trade Marketing, Live Marketing, Relações Públicas, Content Marketing, Produção de Conteúdo, Inbound Marketing, Marketing de Performance, Marketing de Produto.',
      icon: <FaRocket size={60} />
    },
    {
      title: 'TRÁFEGO PAGO',
      text: 'Google Ads, Instagram ADS, LinkedIn ADS, Facebook ADS, Mídia Programática, Otimização de campanhas, Google Analytics, Análise e Otimizações de SEO, Análise de dados e relatórios de performance digital, testes A/B de campanhas digitais, Gestão de funil de vendas online, Lançamento de Infoprodutos, Design Orientado a Conversões.',
      icon: <IoMdMegaphone size={60} />
    },
    {
      title: 'BRANDING E DESIGN',
      text: 'Desenvolvemos todo material online e offline da sua empresa. Marca, logotipo, identidade visual, catálogo, portfólio, folder, comunicação de PDV, apresentação corporativa e promocional, anúncio, banners, cartão digital, embalagem, papelaria, sinalização, fachadas e muito mais.',
      icon: <MdDraw size={60} />
    },
    {
      title: 'DESENVOLVIMENTO WEB',
      text: 'Desenvolvemos todos os tipos de site, com layout personalizado e responsivo; Ecommerce, landing page, hotsite, portal corporativo, blog, projetos com foco em mobile, projetos especiais, otimização web (SEO), e-mail marketing, remarketing e etc.',
      icon: <FaCode size={60} />
    },
    {
      title: 'FOTO E VÍDEO',
      text: 'Produção de vídeos e fotos com equipamentos de primeira linha como instrumentos para divulgação. O formato desses vídeos varia desde vídeos animados, comerciais para TV, cobertura de eventos, festas e casamento à vídeos institucionais e comerciais para redes sociais.',
      icon: <FaCamera size={60} />
    },
    {
      title: 'ASSESSORIA',
      text: 'Parceria com influencers, contratação de artistas, negociação com empresas, produção visual para modelos.',
      icon: <MdConnectWithoutContact size={60} />
    }
  ]

  return (
    <Container>
      <Row className='highlights-row'>
        <span className='cloister-black' style={{ color: '#FFF', fontSize: '60px' }}>Nossos Serviços</span>
        {elements.map((element, index) => (
          <Col key={index} xs={12} sm={12} md={12} lg={4}>
            <Row className='h-100 highlights-row-internal'>
              <Col xs={12} sm={12} md={12} lg={12} className='highlights-col d-flex flex-column justify-content-center align-items-center'>
                <div style={{ padding: '10px' }}>
                  <span>
                    { element.icon }
                  </span>
                </div>
                <div>
                  <h3>
                    { element.title }
                  </h3>
                  <span className='suse highlights-text'>
                    { element.text }
                  </span>
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default Highlights